<template>
  <div class="user-main">
    <div v-if="browserType !== 'chrome'">
      <div class="download">
        <div class="box box-full">
          <div class="box-inner">
            <p>
              {{$t('lang.downloadMsg')}}
            </p>
            <a :href="chrome" target="_blank" class="btn">{{$t('lang.download')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="user-form" v-else>
      <a
        href="http://teacher.bingotalk.cn/"
        class="homepage-btn"
        target="_blank"
        >{{$t('lang.homepage')}}</a
      >
      <span
        class="lang-btn"
        @click="changeLanguage"
      >{{language === "cn" ? "EN" : "中文"}}</span>
      <div class="user-form-img">
        <img src="~assets/images/pic_01@2x.png" alt="" />
      </div>
      <div v-if="language === 'cn'">
        <el-form
        ref="phoneLoginForm"
        :model="phoneLoginForm"
        autoComplete="off"
        :rules="phoneFormRules"
        >
          <div class="form-box">
            <img src="~assets/images/logo-title@2x.png" class="title-logo"/>
            <el-tabs class="select-tab" v-model="loginType" @tab-click="clearValidate">
              <el-tab-pane label="密码登录" name="passwd"></el-tab-pane>
              <el-tab-pane label="短信登录" name="sms"></el-tab-pane>
            </el-tabs>
            <div v-if="loginType === 'passwd'">
              <div class="form-group">
                <el-form-item prop="username">
                  <el-input
                    v-model="phoneLoginForm.username"
                    type="text"
                    placeholder="手机号或邮箱"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-group">
                <el-form-item prop="password">
                  <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="phoneLoginForm.password"
                    :type="passwordType"
                    placeholder="密码"
                    auto-complete="off"
                    @keyup.enter.native="handleMobileLogin"
                  ></el-input>
                  <span class="show-pwd" @click="showPwd">
                    <i v-if="passwordType === 'password'" class="eye-close" />
                    <i v-if="passwordType !== 'password'" class="eye-open" />
                  </span>
                </el-form-item>
              </div>
            </div>
            <div v-if="loginType === 'sms'">
              <div class="form-group">
                <el-form-item prop="mobile">
                  <el-input
                    v-model="phoneLoginForm.mobile"
                    type="text"
                    placeholder="手机号"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-group verify-form-group">
                <div class="verifyinput">
                  <el-form-item prop="verifyCode">
                    <el-input
                      v-model="phoneLoginForm.verifyCode"
                      type="text"
                      placeholder="验证码"
                      auto-complete="off"
                      @keyup.enter.native="handleMobileLogin"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-button @click="getCode" :disabled=smsDisabled round class="get-code">{{smsDisabled ? countdown + '秒后重新获取' : '发送验证码'}}</el-button>
              </div>
            </div>
            <div v-if="loginType === 'passwd'" class="rememberme">
              <el-checkbox
                label="记住密码"
                v-model="rememberme"
                fill="#F29700"
                text-color="#F29700"
                name="autofill"
                @change="handleRememberChange"
              ></el-checkbox>
            </div>
            <el-button
              class="btn btn-login"
              :loading="btnLoading"
              @click.native.prevent="handleMobileLogin"
              >{{$t('lang.loginPage7')}}</el-button
            >
            <p>
              {{$t('lang.loginPage2')}}
              <router-link to="/register" tag="a">{{$t('lang.loginPage3')}}</router-link> {{$t('lang.loginPage4')}}
            </p>
            <p>
              {{$t('lang.loginPage5')}}
              <router-link to="/forgot" tag="a">{{$t('lang.loginPage6')}}</router-link> {{$t('lang.loginPage4')}}
            </p>
          </div>
        </el-form>
      </div>
      <div v-else>
        <el-form
          ref="emailLoginForm"
          :model="emailLoginForm"
          autoComplete="off"
          :rules="emailFormRules"
        >
          <div class="form-box">
            <img src="~assets/images/logo-title@2x.png" class="title-logo" />
            <h2>{{$t('lang.loginPage1')}}</h2>
            <div class="form-group">
              <el-form-item prop="username">
                <el-input
                  v-model="emailLoginForm.username"
                  type="text"
                  :placeholder="$t('lang.loginPage8')"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-group">
              <el-form-item prop="password">
                <el-input
                  :key="passwordTypeEn"
                  ref="passwordEn"
                  v-model="emailLoginForm.password"
                  :type="passwordTypeEn"
                  :placeholder="$t('lang.loginPage9')"
                  auto-complete="off"
                  @keyup.enter.native="handleLogin"
                ></el-input>
                <span class="show-pwd" @click="showPwdEn">
                  <i v-if="passwordTypeEn === 'password'" class="eye-close" />
                  <i v-if="passwordTypeEn !== 'password'" class="eye-open" />
                </span>
              </el-form-item>
            </div>
            <el-button
              class="btn btn-login"
              :loading="btnLoading"
              @click.native.prevent="handleLogin"
              >{{$t('lang.loginPage7')}}</el-button
            >
            <p>
              {{$t('lang.loginPage2')}}
              <router-link to="/register" tag="a">{{$t('lang.loginPage3')}}</router-link> {{$t('lang.loginPage4')}}
            </p>
            <p>
              {{$t('lang.loginPage5')}}
              <router-link to="/forgot" tag="a">{{$t('lang.loginPage6')}}</router-link> {{$t('lang.loginPage4')}}
            </p>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="滑动获取验证码"
      :show-close="false"
      :center="true"
      :width="'350px'"
      :top="'45vh'"
      :visible.sync="dialogSliderVisible"
    >
      <div class="code-slider">
        <nocaptcha
          :appkey="'FFFF0N0000000000662A'"
          :scene="'nc_login_h5'"
          :lang="'cn'"
          @callback="slideToGetCode"
        />
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('lang.browserTipTitle')"
      class="browser-dialog"
      :visible.sync="browserDialogVisible"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true"
      :width="'500px'"
      :top="'25vh'"
    >
      <p>{{$t('lang.browserTip')}}</p>
      <a class="download-btn" :href="$t('lang.ChromeURL')" target="_blank">{{$t('lang.downloadChrome')}}</a>
      <a class="backup-btn" href="https://www.bingotalk.cn/lesson.html" target="_blank"><i class="el-icon-question"></i>{{$t('lang.backupBtn')}}</a>
    </el-dialog>
    <div class="app-bg"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { slideToGetSmsCode } from '@/api/login.js'
import { validateMobile, validateEmail } from '@/utils/validate.js'
import { nocaptcha } from 'vue-nocaptcha'
import '@/utils/Browser'
export default {
  components: {
    nocaptcha
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号或邮箱"));
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        if (!validateEmail(value)) {
          callback(new Error("请输入正确的手机号或邮箱"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    const validatePhoneNum = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    }
    return {
      loginType: 'passwd',
      rememberme: true,
      btnLoading: false,
      smsDisabled: false,
      dialogSliderVisible: false,
      countdown: 60,
      chrome: "https://www.google.com/chrome/",
      browserType: "chrome",
      passwordType: 'password',
      passwordTypeEn: 'password',
      browserDialogVisible: false,
      emailLoginForm: {
        username: "",
        password: ""
      },
      phoneLoginForm: {
        username: "",
        mobile: "",
        password: "",
        verifyCode: ""
      },
      emailFormRules: {
        username: [
          {
            required: true,
            type: "email",
            message: "Please enter a valid email address",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            min: 6,
            max: 14,
            message: "6 to 14 characters in length",
            trigger: "blur"
          }
        ]
      },
      phoneFormRules: {
        username: [
          {
            required: true,
            trigger: "blur",
            validator: validateUsername
          }
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: validatePhoneNum
          }
        ],
        password: [
          {
            required: true,
            min: 6,
            max: 14,
            message: '请输入长度6-14位的密码',
            trigger: "blur"
          }
        ],
        verifyCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["language"])
  },
  created() {
    // this.getBrowserType();
    this.initLanguage();
    this.remember();
    this.getBrowser();
    this.handleWeixin();
  },
  methods: {
    changeLanguage() {
      let lang = this.$i18n.locale === "cn" ? "en" : "cn";
      this.$i18n.locale = lang;
      this.$store
        .dispatch("setLanguage", lang)
        .then(() => {
          localStorage.setItem("language", lang);
          this.$router.push({ path: "/" });
        })
        .catch((e) => {
          console.log(e)
        });
    },
    getBrowser() {
      // eslint-disable-next-line
      var info = new Browser();
      if (info.browser !== 'Chrome') {
        this.browserDialogVisible = true
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    showPwdEn() {
      if (this.passwordTypeEn === 'password') {
        this.passwordTypeEn = ''
      } else {
        this.passwordTypeEn = 'password'
      }
      this.$nextTick(() => {
        this.$refs.passwordEn.focus()
      })
    },
    trimLR() {
      this.phoneLoginForm.username = this.phoneLoginForm.username.replace(/\s+/g, '')
    },
    initLanguage() {
      let lang = this.$i18n.locale
      localStorage.setItem("language", lang)
    },
    remember() {
      const username = localStorage.getItem('login_username_cn')
      const passwd = localStorage.getItem('login_passwd_cn')
      const isRemembered = localStorage.getItem('isRemembered')
      if (isRemembered) {
        this.rememberme = JSON.parse(isRemembered.toLowerCase())
      }
      if (username && passwd) {
        this.phoneLoginForm.username = username
        this.phoneLoginForm.password = passwd
      } else {
        this.phoneLoginForm.username = ''
        this.phoneLoginForm.password = ''
      }
    },
    handleRememberChange() {
      localStorage.setItem('isRemembered', this.rememberme)
      if (!this.rememberme) {
        localStorage.removeItem('login_username_cn')
        localStorage.removeItem('login_passwd_cn')
      }
    },
    clearValidate() {
      this.$refs['phoneLoginForm'].clearValidate();
    },
    getCode() {
      const mobile = this.phoneLoginForm.mobile
      if (mobile === '') {
        this.$message.error('请输入手机号')
        return false
      } else if (!(/^\d+$/.test(mobile))) {
        this.$message.error('请输入手机号')
        return false
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(mobile)) {
        this.$message.error('请输入正确的手机号')
        return false
      }
      this.dialogSliderVisible = true
    },
    slideToGetCode(data) {
      const mobile = this.phoneLoginForm.mobile
      if (mobile === '') {
        this.$message.error('请输入手机号')
        data.nc.reset()
        return false
      } else if (!(/^\d+$/.test(mobile))) {
        this.$message.error('请输入手机号')
        data.nc.reset()
        return false
      }
      slideToGetSmsCode({
        smsCodeType: 'LOGON',
        sessionId: data.csessionid,
        token: data.token,
        scene: data.scene,
        sig: data.sig,
        mobile: '+86' + mobile
      }).then(response => {
        if (response.status !== 200) {
          data.nc.reset()
          this.list = []
          this.$message.error(response.data.message)
        } else {
          if (+response.data.code === 200) {
            this.countdown = 60
            this.smsDisabled = true
            setTimeout(this.tick, 1000)
            this.dialogSliderVisible = false
            data.nc.reset()
          } else {
            data.nc.reset()
            this.$message.error(response.data.message)
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    tick() {
      if (this.countdown === 0) {
        this.smsDisabled = false
      } else {
        this.countdown--
        setTimeout(this.tick, 1000)
      }
    },
    getBrowserType() {
      var u = navigator.userAgent;
      if (u.indexOf("MicroMessenger") > -1) {
        this.browserType = "weixin";
      } else if (u.match(/\sQQ/i) === "qq") {
        this.browserType = "qq";
      } else if (u.indexOf("Chrome") > -1) {
        this.browserType = "chrome";
      } else {
        this.browserType = "browser";
      }
    },
    handleLogin() {
      this.$refs.emailLoginForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          this.$store
            .dispatch("LoginByUsername", this.emailLoginForm)
            .then(response => {
              if (response.status === 200) {
                if (response.data !== "" && response.data.code === 200) {
                  this.btnLoading = false;
                  this.$router.push({ path: "/" });
                } else {
                  this.btnLoading = false;
                  this.$message.error(response.data.message);
                }
              } else {
                this.btnLoading = false;
                this.$message.error(this.$t('lang.loginPage23'));
              }
            })
            .catch(error => {
              if (error.toString().includes(400)) {
                this.$message.error(this.$t('lang.loginPage24'));
              } else {
                this.$message.error(this.$t('lang.loginPage23'));
              }
              this.btnLoading = false;
            });
        }
      });
    },
    handleMobileLogin() {
      this.$refs.phoneLoginForm.validate(valid => {
        if (valid) {
          if (this.loginType === 'passwd') {
            this.btnLoading = true;
            if (this.rememberme) {
              localStorage.setItem('login_username_cn', this.phoneLoginForm.username)
              localStorage.setItem('login_passwd_cn', this.phoneLoginForm.password)
            } else {
              localStorage.removeItem('login_username_cn')
              localStorage.removeItem('login_passwd_cn')
            }
            this.$store
              .dispatch("LoginByUsername", {
                username: validateMobile(this.phoneLoginForm.username) ? '+86' + this.phoneLoginForm.username : this.phoneLoginForm.username,
                password: this.phoneLoginForm.password
              })
              .then(response => {
                if (response.status === 200) {
                  if (response.data !== "" && response.data.code === 200) {
                    this.btnLoading = false;
                    this.$router.push({ path: "/" });
                  } else {
                    this.btnLoading = false;
                    this.$message.error(response.data.message);
                  }
                } else {
                  this.btnLoading = false;
                  this.$message.error(this.$t('lang.loginPage23'));
                }
              })
              .catch(error => {
                if (error.toString().includes(400)) {
                  this.$message.error(this.$t('lang.loginPage24'));
                } else {
                  this.$message.error(this.$t('lang.loginPage23'));
                }
                this.btnLoading = false;
              });
          }
          if (this.loginType === 'sms') {
            this.btnLoading = true;
            this.$store
              .dispatch("LoginBySms", {
                username: '+86' + this.phoneLoginForm.mobile,
                verifyCode: this.phoneLoginForm.verifyCode
              })
              .then(response => {
                if (response.status === 200) {
                  if (response.data !== "" && response.data.code === 200) {
                    this.btnLoading = false;
                    this.$router.push({ path: "/" });
                  } else {
                    this.btnLoading = false;
                    this.$message.error(response.data.message);
                  }
                } else {
                  this.btnLoading = false;
                  this.$message.error(this.$t('lang.loginPage23'));
                }
              })
              .catch(error => {
                if (error.toString().includes(400)) {
                  this.$message.error(this.$t('lang.loginPage24'));
                } else {
                  this.$message.error(this.$t('lang.loginPage23'));
                }
                this.btnLoading = false;
              });
          }
        }
      });
    },
    isWeixin() {
      const u = navigator.userAgent;
      if (u.indexOf("MicroMessenger") > -1) {
        return true
      } else {
        return false
      }
    },
    handleWeixin() {
      if (this.isWeixin()) {
        this.$router.push({ path: "/m/login" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.download {
  width: 998px;
  height: 598px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -300px 0px 0px -500px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 6px;
  p {
    font-size: 20px;
    text-align: center;
    color: #ffa438;
    padding-bottom: 20px;
  }
  .btn {
    width: 320px;
    margin: 0 auto;
  }
}
.user-form {
  width: 998px;
  height: 598px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -300px 0px 0px -500px;
  background-color: $white;
  border-radius: 6px;
  .homepage-btn {
    display: block;
    width: 110px;
    height: 30px;
    line-height: 30px;
    border: 1px solid $baseColor;
    color: $baseColor;
    font-size: 12px;
    text-align: center;
    position: absolute;
    top: 40px;
    left: 80px;
    border-radius: 20px;
  }
  .lang-btn {
    display: block;
    width: 60px;
    height: 30px;
    line-height: 30px;
    border: 1px solid $baseColor;
    color: $baseColor;
    font-size: 12px;
    text-align: center;
    position: absolute;
    top: 40px;
    right: 80px;
    border-radius: 20px;
    cursor: pointer;
    z-index: 10;
  }
}
.user-form-img {
  width: 348px;
  height: 225px;
  float: left;
  margin: 187px 76px;
  img {
    display: block;
    width: 100%;
    line-height: 0;
    border: 0;
  }
}
.form-box {
  width: 400px;
  height: 500px;
  margin: 40px;
  float: right;
  position: relative;
  .title-logo {
    display: block;
    width: 155px;
    height: 58px;
    margin: 40px auto 20px;
  }
  h2 {
    color: $baseColor;
    font-size: 30px;
    text-align: center;
    margin-bottom: 50px;
  }
  .select-tab {
    width: 260px;
    margin: 0px auto 10px;
    /deep/ .el-tabs__header {
      .el-tabs__nav-wrap::after {
      display: none;
      }
      .el-tabs__item {
      color: #1b1b1b;
      }
      .el-tabs__item.is-active {
      color: #1b1b1b;
      }
      .el-tabs__active-bar {
        background-color: #FFA438;
      }
      .el-tabs__item {
        height: 36px;
        width: 86px;
        text-align: center;
        line-height: 36px;
        font-size: 15px;
        font-weight: normal
      }
    }
  }
  .form-group {
    width: 285px;
    height: 36px;
    background: #f5f5f5;
    border-radius: 20px;
    input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-indent: 20px;
      background: transparent;
      border: 0;
      outline: none;
    }
  }
  .verify-form-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: none;
    .verifyinput {
      width: 142px;
    }
    .get-code{
      font-size: 15px;
      color: #F5A623;
      height: 36px;
      background: none;
      line-height: 36px;
      margin: 0;
      border: none;
      padding: 0px 0px;
      width: 100px;
      border-radius: 0px;
    }
  }
  .rememberme {
    width: 285px;
    margin: 0 auto 20px;
    padding-left: 20px;
    
    /deep/ .el-checkbox {
      color: #1b1b1b;
      font-weight: normal;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #1b1b1b;
        font-weight: normal;
      }
      .el-checkbox__inner:hover {
        border-color: #ffa438;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #ffffff;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #ffa438;
      }
      .el-checkbox__inner::after {
        border-color: #ffa438;
      }
    }
    
  }
  .btn {
    width: 285px;
    margin: 0 auto 30px;
  }
  p {
    text-align: center;
    font-size: 18px;
    color: #1b1b1b;
    a {
      color: $baseColor;
      text-decoration: none;
    }
  }
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 0px;
  width: 16px;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;

  .eye-close {
    display: block;
    width: 16px;
    height: 40px;
    background: url(~assets/images/eye-close.png) center center no-repeat;
    background-size: contain;
  }

  .eye-open {
    display: block;
    width: 16px;
    height: 40px;
    background: url(~assets/images/eye-open.png) center center no-repeat;
    background-size: contain;
  }
}

.backup-btn {
  display: block;
  width: 100%;
  height: 20px;
  line-height: 20px;
  margin: 10px auto 0;
  text-align: right;
  font-size: 12px;
  color: #6e6e6e;

  &:hover {
    color: #ff8c29;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue